export default __webpack_public_path__ + "static/media/card_s_green.69ca3dad.png";